import {
  createEventCallbackRedirect,
  EVENT_TIMEOUT_IN_MS,
  sendGAEvent,
} from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import * as actions from '../modules/actions';
import { BreadcrumbLinkClickEvent } from './events';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [actions.breadcrumbLinkClick.type]: (_prevState, _nextState, action) => {
    const {
      payload: { destinationUrl, linkDepth },
    } = action as ReturnType<typeof actions.breadcrumbLinkClick>;

    sendGAEvent(<BreadcrumbLinkClickEvent>{
      event: 'custom_event',
      event_action: 'Link Click',
      event_category: 'Breadcrumb',
      event_label: `${linkDepth} Level(s) Up`,
      destination_URL: destinationUrl,
      eventCallback: createEventCallbackRedirect(destinationUrl),
      eventTimeout: EVENT_TIMEOUT_IN_MS,
    });
  },
};
